import { createContext } from 'react';

/** @internal */
export const MobileMenuModeContext = createContext<boolean>(false);
